export default __webpack_public_path__ + "static/media/01.47df360f.jpg";